export default "__VITE_ASSET__DXVN7Cwl__"